import { createSelector } from 'reselect';
import { dataSelector } from './dataSelector';

export const localNavPlaceholderSelector = createSelector(
  dataSelector,
  appData => appData?.cards?.local_nav_placeholder,
);
